// This file was automatically generated from appchart.dialog.setDateTime.html.
// Please don't edit this file by hand.

goog.provide('el8.template.appchart.dialog.setDateTime');

goog.require('soy');
goog.require('soy.StringBuilder');


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.dialog.setDateTime.content = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="overlayContainer"><form><div class="el8TextareaWrap datePickerWrap fl"><input type="text" class="datePicker" name="date" /></div>', (! opt_data.hideTime) ? '<div class="el8TextareaWrap el8TimeWrap fl"><input type="text" class="" name="time" /></div>' : '', '</form><p class="optional-explanation el8AppColor el8ItalicText padl5"></p></div>');
  if (!opt_sb) return output.toString();
};
